<template lang="pug">
.container-restricao
    div(
        v-if='restricoes.length > 0',
        :class='restricoes[index].inibido ? "camada-inibida" : ""',
        v-for='(restricao, index) in listaRestricoes'
    )
        slot(name='botaoInibir', :restricao='restricoes[index]')
        .card-restricao
            .container-restricao-acoes(
                v-if='habilitarZoomRestricao && (restricoes[index].geometry || restricoes[index].geometria || geometria)'
            )
                div
                    BaseButton(
                        size='small',
                        icon='mdi mdi-crosshairs-gps',
                        @click='aplicarZoomRestricao(index)'
                    )
            slot(name='selecionarRestricao', :restricao='restricoes[index]')
            p
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
                |
                | {{ restricao.nome }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.cpfCnpj') }}:
                |
                | {{ formatDocumento(restricao.cpf_cnpj) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.areaHa') }}:
                |
                | {{ formatNumber(restricao.areaHa) }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.percentualDeSobreposicao') }}:
                |
                | {{ formatNumberPercent(restricao.percentualSobreposicaoGeometria) }}
                br
                b Dano:
                |
                | {{ restricao.dano || '-' }}
                br
                b Termo de embargo:
                |
                | {{ restricao.t_embargo || '-' }}
                br
                b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.ano') }}:
                |
                | {{ restricao.ano || '-' }}
                br
                b Propriedade:
                |
                | {{ restricao.propriedade || '-' }}
                br
                b Coordenada X:
                |
                | {{ restricao.coord_x || '-' }}
                br
                b Coordenada Y:
                |
                | {{ restricao.coord_y || '-' }}
                Criticidade(
                    v-if='restricao.nivelAlerta'
                    :restricao='restricao'
                )
</template>

<script>
import formatters from '@/utils/formatters';
import Criticidade from '@/components/diagnosticoSocioambiental/Criticidade.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'area-embargada-sema-mt',

    data() {
        return {};
    },

    components: {
        Criticidade,
        BaseButton
    },

    props: {
        restricoes: {
            type: Array,
            required: true
        },
        geometria: {
            type: Array,
            required: false,
            default: null
        },
        habilitarZoomRestricao: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        listaRestricoes: function () {
            return this.restricoes.map(value => {
                if (value.properties) {
                    return {
                        ...value.properties
                    };
                }
                return value;
            });
        }
    },

    methods: {
        aplicarZoomRestricao(index) {
            let geometriaQueNaoEstavaDentroDasRestricoes = null;
            if (this.geometria) {
                geometriaQueNaoEstavaDentroDasRestricoes =
                    this.geometria[index];
            }
            this.$emit(
                'aplicar-zoom-restricao',
                this.restricoes[index],
                geometriaQueNaoEstavaDentroDasRestricoes
            );
        },
        formatNumber(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2);
        },
        formatNumberPercent(number) {
            if (!number) return '-';
            return formatters.maxFormatNumber(number, 2) + '%';
        },
        formatDocumento(documento) {
            if (!documento) return '-';
            return formatters.numeralStringFormatToDocumento(formatters.removerPontuacaoDocumentoLgpd(documento));
        }
    }
};
</script>
